export { PlatformLayoutComponent } from './platform.layout';
export { PlatformLayoutModule } from './platform.module';
